import { useTranslations } from '@vocab/react';
import {
  Box,
  Disclosure,
  Stack,
  Strong,
  Text,
  TextLink,
} from 'braid-design-system';

import type { Brand } from 'src/types';

import translations from '../.vocab';

interface Props {
  collectionNoticeUrl: string;
  privacyUrl: string;
  brand: Brand;
}

export function PrivacyStatement({
  collectionNoticeUrl,
  privacyUrl,
  brand,
}: Props) {
  const { t } = useTranslations(translations);

  return (
    <Text size="small" tone="secondary">
      <Stack space="xsmall">
        <Box component="p">{t('PDPA message')}</Box>
        <Disclosure
          id="readMore"
          weight="weak"
          space="small"
          expandLabel={t('More about Privacy')}
          collapseLabel={t('More about Privacy')}
        >
          <Stack space="medium">
            <Stack space="xsmall">
              <Strong>{t('Protect your privacy')}</Strong>
              <Box component="p">{t('Protect your privacy description')}</Box>
            </Stack>
            <Stack space="xsmall">
              <Strong>{t('How SEEK uses your data', { brand })}</Strong>
              <Box component="p">
                {t('How SEEK uses your data description', { brand })}
              </Box>
              <Box component="p">
                {t('Default resume statement', { brand })}
              </Box>
              <Box component="p">{t('Remove external links')}</Box>
              <Box component="p">
                {t('Delete file from profile', { brand })}
              </Box>
              <Box component="p">{t('If selected by', { brand })}</Box>
              <Box component="p">
                {t('Privacy info link', {
                  CollectionNotice: () => (
                    <TextLink
                      href={collectionNoticeUrl}
                      weight="weak"
                      target="_blank"
                    >
                      {t('Collection Notice')}
                    </TextLink>
                  ),
                  PrivacyStatement: () => (
                    <TextLink href={privacyUrl} weight="weak" target="_blank">
                      {t('Privacy Statement')}
                    </TextLink>
                  ),
                })}
              </Box>
            </Stack>
          </Stack>
        </Disclosure>
      </Stack>
    </Text>
  );
}
